<template>
  <action-type-template :type="'Detail1'" :action="action" :items="items" grid="detail1" />
</template>

<script>
import ActionTypeTemplate from './ActionTypeTemplate'

export default {
  name: 'SportFootballMatchActionDetail1',
  components: { ActionTypeTemplate },
  props: {
    action: Object
  },
  computed: {
    items () {
      return this.$store.getters['Sport/Football/Action/Detail1/list'].filter(
        (item) => { return item.typeId === this.action.typeId }
      )
    }
  }
}
</script>
